export const getUsageRingColor = (percentUsed: number, isDark: boolean): string => {
  if (percentUsed >= 100) return '#dc2626';
  if (percentUsed >= 90) return '#f97316';
  if (percentUsed >= 75) return '#f59e0b';
  return isDark ? '#d4d4d4' : '#171717';
};

export const getUsageBarColor = (percentUsed: number): string => {
  if (percentUsed >= 100) return 'bg-red-600';
  if (percentUsed >= 90) return 'bg-orange-500';
  if (percentUsed >= 75) return 'bg-amber-500';
  return 'bg-foreground';
};

export const getUsageTextColor = (percentUsed: number): string => {
  if (percentUsed >= 100) return 'text-red-600';
  if (percentUsed >= 90) return 'text-orange-500';
  if (percentUsed >= 75) return 'text-amber-500';
  return 'text-muted-foreground';
};
